import React from "react";
import Lottie from "lottie-react";
import { twMerge } from "tailwind-merge";

import { SupLoader } from "../../../../components/UI/Loader";
import { SupText } from "../../../../components/UI/Text";

import superforming from "../assets/superforming.json";

interface NoDataProps {
  tableName?: string;
  loading?: boolean;
  filtered?: boolean;
  description?: string;
  message?: string;
  className?: string;
}

export function NoData({
  tableName,
  loading,
  filtered,
  description = "Your current applied filters may be filtering out results",
  message = "NO RESULTS FOUND",
  className,
}: NoDataProps) {
  if (loading) {
    return (
      <div className="col-span-full flex justify-center items-center">
        <SupLoader className="w-10" />
      </div>
    );
  }

  return (
    <div className={twMerge("sup-datagrid-empty text-neutral-900 flex justify-center items-center", className)}>
      <div className="w-72">
        <div className="flex items-center gap-2 h-12 w-[148px] px-3 border-0.5 border-b-0 border-neutral-600 rounded-tr-3xl">
          <Lottie animationData={superforming as unknown} loop={true} style={{ height: "100%" }} />
          <div className="text-[16px] leading-[16px] -tracking-[0.5px]">Superform</div>
        </div>

        {!filtered && tableName && (
          <div className="flex items-center justify-center w-full border-0.5 border-neutral-600">
            <div className="font-bold text-5xl leading-loose -tracking-[0.5px]">{tableName}</div>
          </div>
        )}

        {filtered && description && (
          <div className="flex items-center justify-center w-full border-0.5 border-neutral-600">
            <SupText variant="caption" className="leading-loose p-4">
              {description}
            </SupText>
          </div>
        )}

        <div className="flex justify-center items-center rounded-b-3xl w-full h-12 bg-neutral-600 text-neutral-50 whitespace-nowrap cursor-default uppercase">{message}</div>
      </div>
    </div>
  );
}
